<p>Kies de afdeling(en) om de medewerkers van die afdelingen in de planning te zien:</p>
<p-multiSelect [options]="afdelingen" [(ngModel)]="selectedAfdelingen" ></p-multiSelect>
<button mat-raised-button (click) = "btnOpslaan()" color="accent">Opslaan</button>